import { StemFileUrls } from './MLStemSplitterJob'
import { VoiceModel } from './VoiceModel'
import { BaseModel } from './common'

export const PROJECT_DEFAULT_INSTRUMENT_NAME = 'DEFAULT'

export interface ProjectMetadata {
  startTimeMs?: number
  endTimeMs?: number
  splitInstrumental?: boolean
  dereverb?: boolean
  deharmony?: boolean
}

export interface Project extends BaseModel {
  name: string
  audioDurationMs: number
  audioUrls: StemFileUrls
  createdAt: string
  originalInputFileName: string | null
  vocalFileInstrumentName: string | null
  aiUserId: number
  voiceModels?: VoiceModel[]
  mlStemSplitterJobId: number | null
  metadata: ProjectMetadata
}
